export const SAVE_MATTERS_REQUEST = "SAVE_MATTERS_REQUEST";
export const SAVE_MATTERS_SUCCESS = "SAVE_MATTERS_SUCCESS";
export const SAVE_MATTERS_FAIL = "SAVE_MATTERS_FAIL";
export const SAVE_MATTERS_RESET = "SAVE_MATTERS_RESET";